export default function AppInput({ value, onChange, className, ...props }) {
  return (
    <input value={value ?? ""} onChange={(event) => onChange(event.target.value)} type={props?.type ?? "text"} className={`form ${className}`} {...props} />
  );
}
